import React from 'react';

// données
import { useAuthContext } from '../context/AuthContext';
import UserPokemonList from '../components/Pokemon/UserPokemonList';
import styles from '../styles/PokemonList.module.css'

// styles

const PokemonPage = ({period, pokemon, onClose}) => {
    const { user, token } = useAuthContext();

    return (
        <div className={styles.pointerNone}>
            {user && token && <UserPokemonList userId={user.id} token={token} period={period} pokemon={pokemon} onClose={onClose} />}
        </div>
    );
};

export default PokemonPage;